var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'async-'+_vm.component +' async-component'},[(_vm.remote && !_vm.hasError)?_c(_vm.remote,{ref:"asyncComponent",tag:"component",attrs:{"test":_vm.test},on:{"handler":_vm.haha}}):_vm._e(),(_vm.hasError)?_c('div',{staticClass:"error-fallback"},[_c('p',[_vm._v("Failed to load remote component: "+_vm._s(_vm.component))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }